export default "__VITE_ASSET__CAk9PVN4__"